import React, {useEffect, useState} from "react";
import {FxmsData} from "../../../datas/FxData";
import { StyledEngineProvider } from "@mui/material/styles";
import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/Button";
import {FormControlLabel, FormGroup, Switch, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import DeleteIcon from "@mui/icons-material/Delete";

export const MultilineTextBox = (props) => {

    const [content, setContent] = useState('CONTENT');
    const [color, setColor] = useState("white")
    const [size, setSize] = useState('30px');
    const [background, setBackground] = React.useState([]);
    const [open, setOpen] = useState(false)
    const [multi, setMulti] = useState(true)
    useEffect(()=>{
        if(props.item.fxUiDashbItemAttrs){
            handleColorChange({target:{value:props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='color').attrVal}})
            handleContentChange({target:{value:props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='content').attrVal}})
            handleSizeChange({target:{value:parseInt(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='size').attrVal)}})
        }
    },[])

    const handleColorChange = (e) => {
        setColor(e.target.value)
    }

    const handleContentChange = (e) => {
        setContent(e.target.value)
    }
    const handleSizeChange = (e) => {
        setSize(e.target.value)
    }
    const handleSave = () => {
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'content',attrVal:content,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'color',attrVal:color,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'size',attrVal:size,attrType:'string'})
        props.save(currentData,props.item.uiNo,props.item.opId)
    }
    const handleMultiChange = (e) =>{
        setMulti(e.target.checked)
    }
    const removeItem = () => {
        props.removeItem(props.item.uiNo)
    }
    return (
        <StyledEngineProvider>
            <div style={{fontSize:size,color:color,backgroundColor:background}}>
                <TextField fullWidth={true} maxRows={10} multiline={multi}
                    InputProps={{ disableUnderline: true, readOnly:!props.editable }} variant="standard"
                    sx={{textarea:{color:color,fontSize:size+'px',padding:'none'}, margin:'5px'}}
                    value={content}  onChange={handleContentChange}/>
            </div>

                {props.editable ? <input style={{width:'100px'}} type="color" value={color} onChange={handleColorChange} /> : ''}
                {props.editable ? <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                             type="number" value={size} onChange={handleSizeChange} /> : ''}

                {props.editable ? <Button variant={"contained"} onClick={handleSave}>SAVE</Button>: ''}

        </StyledEngineProvider>
    )
}